import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface ReindexContainerData {
  schemaUuid?: string;
  containerUuid: string;
}

interface ReindexContainerResponse {
  failReason: string | null;
  succeeded: boolean;
}

export function useReindexContainer() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      reindexData: ReindexContainerData
    ): Promise<ReindexContainerResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/reindex_container_with_schema`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(reindexData),
        }
      );

      const data = await response.json();

      return {
        failReason: data?.data?.failReason || null,
        succeeded: data?.data?.succeeded || false,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['userContainers']
      });
    },
  });
}
